import { Popup } from "antd-mobile"
import styles from './style.scss'
import { IPhoneData } from "../../types/common"

interface Iprops {
    onCancel(): void
    visible: boolean
    title?: string
    phoneList: IPhoneData[]
}


const loop = () => { }

// 数据由外部传入
export default function ServicePhonePopup(props: Iprops) {
    const {
        onCancel = loop,
        visible = false,
        title = "联系客服",
        phoneList = [],
    } = props

    return (
        <Popup
            visible={visible}
            onMaskClick={onCancel}
            showCloseButton
            getContainer={() => document.body}
            bodyStyle={{
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
            }}
            onClose={onCancel}
        >
            <div className={styles.customerService}>
                <h3 className={styles.customerPopupTitle}>{title || '联系客服'}</h3>
                {(phoneList || []).map((item: any, index: number) => {
                    return item.enable ? (
                        <a
                            className={styles.customerPopupItem}
                            key={index}
                            href={`tel:${item.tel}`}
                        >
                            {item.tel} ({item.name})
                        </a>
                    ) : (
                        ''
                    )
                })}
            </div>
        </Popup>
    )
}